import gql from 'graphql-tag';

import { cartFields } from './cart-queries';

export const GET_BRAND_DOES_FIT_DATA = gql`
  query getBrandDoesFitData(
    $categoryCode: String!
    $productType: ProductTypeEnum!
    $storeCode: String!
    $vehicleInfo: VehicleInput!
  ) {
    checkFit(vehicleInfo: $vehicleInfo) {
      brandCategory(
        categoryCode: $categoryCode
        productType: $productType
        storeCode: $storeCode
      )
    }
  }
`;

export const GET_PRODUCT_DOES_FIT_DATA = gql`
  query CheckProduct(
    $vehicleInfo: VehicleInput!
    $storeCode: String!
    $productCodes: [String]
  ) {
    checkFit(vehicleInfo: $vehicleInfo) {
      product(productCodes: $productCodes, storeCode: $storeCode) {
        doesFit
        productCode
      }
    }
  }
`;

export const GET_STAGGERED_PRODUCT_DOES_FIT_DATA = gql`
  query CheckProduct(
    $vehicleInfo: VehicleInput!
    $storeCode: String!
    $productCodes: [ProductCode]
  ) {
    checkFit(vehicleInfo: $vehicleInfo) {
      productSets(productCodes: $productCodes, storeCode: $storeCode) {
        doesFit
        productCode
      }
    }
  }
`;

export const CHECK_CART_ITEMS_WITH_FITMENT = gql`
  query checkCartItemsWithFitment(
    $vehicleInfo: VehicleInput!
    $storeCode: String!
  ) {
    checkFit(vehicleInfo: $vehicleInfo) {
      cartItems(storeCode: $storeCode) {
        doesFit
        productCode
      }
    }
  }
`;

export const REMOVE_MISTFIT_CART_ITEMS = gql`
  mutation CheckFitClearCart($vehicleInfo: VehicleInput!, $storeCode: String!) {
    checkFit(vehicleInfo: $vehicleInfo) {
      removeCartItemsThatDontFit(storeCode: $storeCode) {
        ...cartFields
      }
    }
  }
  ${cartFields}
`;
